/* SortlyHub theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ---------------- Mobile nav (slide-out drawer) ---------------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  var navOverlay = document.querySelector('[data-nav-overlay]');
  var navClose = document.querySelector('[data-nav-close]');

  function openNav() {
    if (!siteNav) return;
    siteNav.classList.add('is-open');
    navOverlay && navOverlay.classList.add('is-open');
    navToggle && navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (!siteNav) return;
    siteNav.classList.remove('is-open');
    navOverlay && navOverlay.classList.remove('is-open');
    navToggle && navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      if (siteNav.classList.contains('is-open')) { closeNav(); } else { openNav(); }
    });
  }
  navOverlay && navOverlay.addEventListener('click', closeNav);
  navClose && navClose.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); refreshDrawer(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
  });
  overlay && overlay.addEventListener('click', closeDrawer);

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderDrawerLine(item) {
    var img = item.image ? '<div class="cart-line__img"><img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy"></div>' : '';
    return (
      '<div class="cart-line" data-line-key="' + item.key + '" style="margin-bottom:1.4em;">' +
        img +
        '<div style="flex:1;">' +
          '<div class="cart-line__title">' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="body-sm">' + item.variant_title + '</div>' : '') +
          '<div class="buy-row" style="margin:.6em 0;">' +
            '<span class="qty-stepper">' +
              '<button type="button" data-drawer-qty="-1" data-key="' + item.key + '" aria-label="Decrease quantity">–</button>' +
              '<input type="text" readonly value="' + item.quantity + '" data-drawer-qty-input>' +
              '<button type="button" data-drawer-qty="1" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<span class="price" style="font-size:1rem;">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-drawer-remove data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  /* Full repaint — only safe when nothing is still in flight. */
  function paintCart(cart) {
    updateCartCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-drawer-body]');
    var foot = drawer.querySelector('[data-cart-drawer-subtotal]');
    if (body) {
      if (cart.items.length === 0) {
        body.innerHTML = '<p class="body-sm">Your cart is quiet — nothing added yet.</p>';
      } else {
        body.innerHTML = cart.items.map(renderDrawerLine).join('');
      }
    }
    if (foot) foot.textContent = money(cart.total_price);
    bindDrawerLineEvents();
  }

  /* Light update — totals only, never touches the quantity inputs. */
  function paintTotals(cart) {
    updateCartCount(cart.item_count);
    if (drawer) {
      var foot = drawer.querySelector('[data-cart-drawer-subtotal]');
      if (foot) foot.textContent = money(cart.total_price);
    }
  }

  function refreshDrawer() {
    if (!drawer) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(paintCart)
      .catch(function () {});
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) { el.textContent = count; });
  }

  function bindDrawerLineEvents() {
    drawer.querySelectorAll('[data-drawer-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-drawer-qty'), 10);
        var key = btn.getAttribute('data-key');
        var stepper = btn.closest('.qty-stepper');
        var input = stepper && stepper.querySelector('[data-drawer-qty-input]');
        if (!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        queueQtyChange(key, next);
      });
    });
    drawer.querySelectorAll('[data-drawer-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('.cart-line');
        if (line) line.style.opacity = '.4';
        commitChange(btn.getAttribute('data-key'), 0);
      });
    });
  }

  /* ---------------- Cart writes ----------------
     Rapid clicks on one line collapse into a single request, and the drawer
     is only rebuilt once everything has settled — otherwise a slow earlier
     response would overwrite a newer number and make it jump around. */
  var pendingQty = {};
  var qtyTimers = {};
  var inflight = 0;

  function hasPending() {
    for (var k in pendingQty) { if (Object.prototype.hasOwnProperty.call(pendingQty, k)) return true; }
    return false;
  }

  function queueQtyChange(key, quantity) {
    pendingQty[key] = quantity;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      var q = pendingQty[key];
      delete pendingQty[key];
      commitChange(key, q);
    }, 320);
  }

  function commitChange(key, quantity) {
    inflight++;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        inflight--;
        syncCartPage(cart);
        if (inflight === 0 && !hasPending()) {
          paintCart(cart);
        } else {
          paintTotals(cart);
        }
        return cart;
      })
      .catch(function () { inflight--; });
  }

  /* ---------------- Add to cart (product form) ---------------- */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var formData = new FormData(form);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }
      openDrawer();
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { refreshDrawer(); })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.label; }
        });
    });
  });

  /* ---------------- Quantity stepper (product page + cart page) ---------------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-decrease]');
    var plus = stepper.querySelector('[data-qty-increase]');
    function setVal(v) {
      v = Math.max(1, v);
      input.value = v;
      if (stepper.hasAttribute('data-cart-line')) {
        queueQtyChange(stepper.getAttribute('data-cart-line'), v);
      }
    }
    minus && minus.addEventListener('click', function () { setVal((parseInt(input.value, 10) || 1) - 1); });
    plus && plus.addEventListener('click', function () { setVal((parseInt(input.value, 10) || 1) + 1); });
  });

  /* ---------------- Cart page totals ---------------- */
  function syncCartPage(cart) {
    var total = document.querySelector('[data-cart-page-total]');
    if (!total) return;
    total.textContent = money(cart.total_price);
    var countLabel = document.querySelector('[data-cart-page-count]');
    if (countLabel) countLabel.textContent = cart.item_count;
    cart.items.forEach(function (item) {
      var stepper = document.querySelector('[data-cart-line="' + item.key + '"]');
      var row = stepper && stepper.closest('tr');
      var priceCell = row && row.querySelector('.price');
      if (priceCell) priceCell.textContent = money(item.final_line_price);
    });
    if (cart.item_count === 0) window.location.reload();
  }
  document.querySelectorAll('[data-cart-remove-line]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var row = btn.closest('tr');
      if (row) row.style.opacity = '.4';
      commitChange(btn.getAttribute('data-cart-remove-line'), 0).then(function () {
        if (row) row.remove();
      });
    });
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImg && full) mainImg.setAttribute('src', full);
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------------- Header scroll shadow ---------------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 2px 14px rgba(38,52,42,.08)' : 'none';
    }, { passive: true });
  }

  /* ---------------- Product card reveal animation ---------------- */
  var revealCards = document.querySelectorAll('.collection-grid > .product-card, .related-grid > .product-card');
  if (revealCards.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      revealCards.forEach(function (card) { revealObserver.observe(card); });
    } else {
      revealCards.forEach(function (card) { card.classList.add('is-visible'); });
    }
  }
})();
